import { render, staticRenderFns } from "./AgilePickupDeclaredValueTable.vue?vue&type=template&id=0359b74f&scoped=true"
import script from "./AgilePickupDeclaredValueTable.vue?vue&type=script&lang=ts"
export * from "./AgilePickupDeclaredValueTable.vue?vue&type=script&lang=ts"
import style0 from "./AgilePickupDeclaredValueTable.vue?vue&type=style&index=0&id=0359b74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0359b74f",
  null
  
)

export default component.exports